// Kill-switch adapter. Records nothing, no `dataLayer` push, no
// network call, no cookie write. Used as the explicit emergency lever
// per design §I *Rollback / kill switch*.

export const offAdapter = {
    name: 'off',
    init(_config) {
        if (typeof console !== 'undefined' && console.info) {
            console.info('[ga:off] analytics disabled via REACT_APP_ANALYTICS_PROVIDER=off');
        }
    },
    track(_name, _params, _context) {
        /* no-op */
    },
    identify(_userId, _userProps) {
        /* no-op */
    },
    setConsent(_state) {
        /* no-op */
    },
    pageView(_routeId, _params, _context) {
        /* no-op */
    },
};
